<banner>
	<span />
	<h1>GW2W Easy Mode</h1>
</banner>


<style>
span {
	height: 100px;
	width: 100%;
	background-image: url('https://d3b4yo2b5lbfy.cloudfront.net/wp-content/uploads/2016/11/6c5d32016-11_LWS3_Ep3_HomeBanner.jpg');
	background-position: right -300px;
	background-repeat: no-repeat;
	background-color: white;
	position: absolute;
	top: 0;
}

h1 {
	text-align: left;
	padding-left: 0px;
	background-color: rgba(100,100,100,1);
	margin: 0.25em 0em 0.5em 0em;
	padding: 0.25em;
	font-size: 2em;
	font-family: 'Century Gothic', sans-serif;
	font-weight: 400;
	color: rgb(230,230,200);
	padding-top: 100px;
}
</style>